export const hasIndexedDb = () => typeof window !== 'undefined' && !!window.indexedDB;

export const requestToPromise = request =>
  new Promise((resolve, reject) => {
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });

export const openIndexedDb = ({dbName, version, onUpgradeNeeded}) =>
  new Promise((resolve, reject) => {
    if (!hasIndexedDb()) {
      resolve(null);
      return;
    }

    const request = window.indexedDB.open(dbName, version);

    request.onupgradeneeded = event => {
      if (onUpgradeNeeded) {
        onUpgradeNeeded(event.target.result, event);
      }
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });

export const withIndexedDbStore = ({dbName, version, storeName, mode = 'readonly', onUpgradeNeeded}, callback) =>
  openIndexedDb({dbName, version, onUpgradeNeeded}).then(db => {
    if (!db) {
      return null;
    }

    return new Promise((resolve, reject) => {
      const transaction = db.transaction(storeName, mode);
      const store = transaction.objectStore(storeName);
      const result = callback(store, transaction);

      transaction.oncomplete = () => {
        db.close();
        resolve(result);
      };
      transaction.onerror = () => {
        db.close();
        reject(transaction.error);
      };
      transaction.onabort = () => {
        db.close();
        reject(transaction.error);
      };
    });
  });
